import setValue from '../../shared/actions/setValue'


const showMobileMap = (show, dispatch) => {
  if (show) {
    document.body.classList.add('no-scroll-full-map')
  } else {
    document.body.classList.remove('no-scroll-full-map')
  }

  dispatch(setValue('mobileMap', show))
}

export default (show = true) => dispatch => showMobileMap(show, dispatch)
